import { Link } from "react-router-dom";
import type { Topic } from "@/types/topic";
import StatusBadge from "./StatusBadge";

type TopicCardProps = {
  topic: Topic;
  variant?: "grid" | "wide";
};

export default function TopicCard({ topic, variant = "grid" }: TopicCardProps) {
  const isWide = variant === "wide";

  return (
    <article
      className={`group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
        isWide ? "flex flex-col md:flex-row" : "flex flex-col"
      }`}
    >
      <Link
        to={`/topics/${topic.id}`}
        className={`block shrink-0 cursor-pointer overflow-hidden ${
          isWide ? "md:w-64" : ""
        }`}
        tabIndex={-1}
        aria-hidden="true"
      >
        <div
          className={`relative w-full overflow-hidden bg-background-200 ${
            isWide ? "h-48 md:h-full" : "h-48"
          }`}
        >
          <img
            src={topic.cover}
            alt={`${topic.title}配图`}
            title={`${topic.title} - 诱惑吃瓜事件复盘`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3">
            <StatusBadge status={topic.status} />
          </span>
        </div>
      </Link>

      <div className={`flex flex-1 flex-col p-4 md:p-5 ${isWide ? "" : ""}`}>
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-800">
            {topic.category}
          </span>
          <span>{topic.date}</span>
          <span className="hidden sm:inline">· {topic.readTime}</span>
        </div>

        <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link
            to={`/topics/${topic.id}`}
            className="cursor-pointer transition-colors hover:text-primary-600"
          >
            {topic.title}
          </Link>
        </h3>

        <p className="mt-2.5 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
          {topic.summary}
        </p>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center text-primary-500">
              <i className="ri-fire-line" aria-hidden="true"></i>
            </span>
            热度 {topic.heat.toLocaleString()}
          </span>
          <Link
            to={`/topics/${topic.id}`}
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看完整复盘
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>
      </div>
    </article>
  );
}